module.exports = __webpack_public_path__ + "static/img/tese-img3.2abc69d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/tese-img3.png
// module id = 933
// module chunks = 0